<script>
    import {Listeners} from "../../../constants/listeners";
    import {nextTick} from "vue";
    import AdaptersDialog from "../../../component/adapters/Dialog.vue";
    import {store} from "../store";
    import Fieldset from "primevue/fieldset";
    import Checkbox from "primevue/checkbox";
    import RadioButton from "primevue/radiobutton";
    import AdaptersHelpInfo from "../../../component/adapters/HelpInfo.vue";
    import AdaptersDropdown from "../../../component/adapters/Dropdown.vue";
    import Button from "primevue/button";

    export default {
        data () {
            return {
                name:"ExportCluster",
                loading: false,
                error: null,
                model: {},
                parent: null,
                locale: window.locale,
                store: store,
                dropdownNumberOptions: [
                    {caption: '0-9', value: 'asc'},
                    {caption: '9-0', value: 'desc'},
                ],
                dropdownWordOptions: [
                    {caption: this.$t('lang.cluster.a_z'), value: 'asc'},
                    {caption: this.$t('lang.cluster.z_a'), value: 'desc'},
                ],
            }
        },
        mounted() {
            let self = this;

            this.$emitter.on(Listeners.CLUSTER_EXPORT_NODE, (item) => {
                self.onOpen();
                self.parent = item;
            });

        },
        methods: {
            doExportCluster() {
                let self = this;

                if (this.parent) {
                    this.model.parent = this.parent.id;
                }

                window.open(this.getApiUrl + '?' + Object.keys(this.model).map(key => `${key}=${encodeURIComponent(this.model[key])}`).join('&'), '_blank');

                setTimeout(function() {
                    self.onClose();
                }, 500);
            },
            onClose(){
                this.parent = null;
                this.$emitter.emit(this.getDialogListenerClose);
            },
            onOpen() {
                this.model = {
                    includeUnallocated: false,
                    skipEmptyNode: true,
                    exportType: 0,
                    sortByWord: false,
                    sortByWs: false,
                    sortByWsk: true,
                    dirWord: 'asc',
                    dirWs: 'desc',
                    dirWsk: 'desc',
                };
                this.$emitter.emit(this.getDialogListenerOpen);
            }
        },
        computed: {
            getUid() {
                return this.store.getters.uid();
            },
            getApiUrl(){
                return this.$config.API_URL + '/clustering/' + this.getUid + '/export';
            },
            getDialogListenerOpen() {
                return Listeners.CLUSTER_POPUP_EXPORT_NODE_OPEN;
            },
            getDialogListenerClose() {
                return Listeners.CLUSTER_POPUP_EXPORT_NODE_CLOSE;
            }
        },

        watch: {
            'model.exportType'(val){
                if(val === 2){
                    this.model.skipEmptyNode = false;
                }
            },
        },

        components: {
            AdaptersHelpInfo,
            AdaptersDialog,
            Fieldset,
            Checkbox,
            RadioButton,
            AdaptersDropdown,
            Button,
        }
    }
</script>
<template>
    <div>
        <Button
            @click="onOpen"
            :label="$t('lang.main.btn.export')"
            :title="$t('lang.cluster.export_csv_helper')"
            size="small"
            icon="fa fa-file-o"
            id="tour-step-12"
            class="flex w-full sm:w-auto"
            :pt="{
                icon: { class: 'hidden sm:block' }
            }"
        />
        <AdaptersDialog
            :listener-id="getDialogListenerOpen"
            :listener-close-id="getDialogListenerClose"
            :header="$t('lang.cluster.export_setting')"
            :loading="loading"
            :callback-agree="doExportCluster"
            :button-agree-label="$t('lang.main.btn.loading_c')"
            :callback-on-hide="onClose"
        >
            <template #content>
                <Fieldset :legend="$t('lang.cluster.export_fieldset_general_title')">
                    <div v-if="!parent" class="field-checkbox">
                        <Checkbox v-model="model.includeUnallocated" inputId="includeUnallocated" binary />
                        <label for="includeUnallocated">{{ $t('lang.cluster.include_in_group_unall') }}</label>
                    </div>
                    <div class="field-checkbox">
                        <Checkbox v-model="model.skipEmptyNode" inputId="skipEmptyNode" binary :disabled="model.exportType === 2" />
                        <label for="skipEmptyNode">{{ $t('lang.cluster.skip_empty_group') }}</label>
                    </div>
                    <div class="field-radiobutton">
                        <RadioButton v-model="model.exportType" inputId="exportTypeA" :value="0" />
                        <label for="exportTypeA">
                            {{ $t('lang.cluster.format_a') }}
                            (<a :href="'/resources/' + locale + '/cluster_export_a.csv'">{{$t('lang.cluster.select_file_example')}}</a>)
                        </label>
                    </div>
                    <div class="field-radiobutton">
                        <RadioButton v-model="model.exportType" inputId="exportTypeB" :value="1" />
                        <label for="exportTypeB">
                            {{ $t('lang.cluster.format_b') }}
                            (<a :href="'/resources/' + locale + '/cluster_export_b.csv'">{{$t('lang.cluster.select_file_example')}}</a>)
                        </label>
                    </div>
                    <div class="field-radiobutton">
                        <RadioButton v-model="model.exportType" inputId="exportTypeKC" :value="2" />
                        <label for="exportTypeKC">{{ $t('lang.cluster.format_key_coll') }}</label>
                    </div>
                </Fieldset>
                <Fieldset :legend="$t('lang.main.f_sort_label')">
                    <div class="grid">
                        <div class="col-12 md:col-4">
                            <div class="field-checkbox">
                                <Checkbox v-model="model.sortByWs" binary inputId="sortByWs" :disabled="model.exportType === 2" />
                                <label for="sortByWs">{{ $t('lang.main.f_ws_label') }}</label>
                            </div>
                            <AdaptersDropdown
                                v-model="model.dirWs"
                                :options="dropdownNumberOptions"
                                option-label="caption"
                                option-value="value"
                                class="w-full"
                                :disabled="model.exportType === 2 || !model.sortByWs"
                            />
                        </div>
                        <div class="col-12 md:col-4">
                            <div class="field-checkbox">
                                <Checkbox v-model="model.sortByWsk" binary inputId="sortByWsk" :disabled="model.exportType === 2" />
                                <label for="sortByWsk">{{ $t('lang.main.f_wsk_label') }}</label>
                            </div>
                            <AdaptersDropdown
                                v-model="model.dirWsk"
                                :options="dropdownNumberOptions"
                                option-label="caption"
                                option-value="value"
                                class="w-full"
                                :disabled="model.exportType === 2 || !model.sortByWsk"
                            />
                        </div>
                        <div class="col-12 md:col-4">
                            <div class="field-checkbox">
                                <Checkbox v-model="model.sortByWord" binary inputId="sortByWord" :disabled="model.exportType === 2" />
                                <label for="sortByWord">{{ $t('lang.main.f_key_label') }}</label>
                            </div>
                            <AdaptersDropdown
                                v-model="model.dirWord"
                                :options="dropdownWordOptions"
                                option-label="caption"
                                option-value="value"
                                class="w-full"
                                :disabled="model.exportType === 2 || !model.sortByWord"
                            />
                        </div>
                        </div>
                </Fieldset>
            </template>
        </AdaptersDialog>
    </div>
</template>
<style scoped>
    label {width: 100%;}
    .filter label {margin-top: 0}
    .filter select {width: 100%;}
</style>
